import { api } from "../../../utils/api";

// GET DC IN LIST
export const fetchDcIn = async (page = 1) => {
  const res = await api.get(`/dc-in?page=${page}`);
  return res.data;
};

export const getDcInDropdown = async () => {
  const res = await api.get("/dc-in/list/dropdown");
  return res.data.data;
}

// CREATE DC IN
export const createDcIn = async (payload) => {
  const res = await api.post("/dc-in", payload);
  return res.data;
};

// GET DC IN ITEM STOCK
export const fetchDcInItemsStock = async (itemId) => {
  const res = await api.get(`/dc-in/${itemId}/items-stock`);
  return res.data.data;
}